import { useCallback } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { FloorplanClient } from '@/features/storage/FloorplanClient';
import { ownerSearch } from '@/features/storage/OwnerFilter';

interface FloorplanSearch {
  /** The search on the plan, in the URL so a refresh or a shared link keeps it. */
  q?: string;
  /** The owner chosen for all of Opslag, by its slug (owners, step 7). */
  owner?: string;
}

export const Route = createFileRoute('/_shell/storage/floorplans/$floorplanId')({
  validateSearch: (search: Record<string, unknown>): FloorplanSearch => ({
    q: typeof search['q'] === 'string' && search['q'] ? search['q'] : undefined,
    owner: ownerSearch(search),
  }),
  component: FloorplanRoute,
});

function FloorplanRoute() {
  const { floorplanId } = Route.useParams();
  const { q, owner } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const onOwner = useCallback(
    (next: string | undefined) =>
      void navigate({ search: (prev) => ({ ...prev, owner: next }), replace: true }),
    [navigate],
  );
  return (
    // Keyed: another plan is a fresh screen — no selection or view carries over.
    <FloorplanClient
      key={floorplanId}
      floorplanId={floorplanId}
      query={q ?? ''}
      onQuery={(next) =>
        void navigate({ search: (prev) => ({ ...prev, q: next || undefined }), replace: true })
      }
      owner={owner}
      onOwner={onOwner}
    />
  );
}
